import React from "react";
import { renderStrapiContent } from "../utils/contentfulOptions";
import StrapiImage from "./StrapiImage";

const WineModal = ({ content }) => {
  if (!content) {
    return null;
  }

  const {
    wine_name,
    description,
    the_name,
    the_wine,
    the_grape,
    keywords,
    wine_art,
  } = content;

  const wineArt = StrapiImage(wine_art);

  const renderGrape = () => {
    return (
      <div className="m-t-30">
        <h3>The Grape</h3>
        {renderStrapiContent(the_grape)}
      </div>
    );
  };

  const renderName = () => {
    return (
      <div className="m-t-30">
        <h3>The Name</h3>
        {renderStrapiContent(the_name)}
      </div>
    );
  };

  const renderWine = () => {
    return (
      <div className="m-t-30">
        <h3>The Wine</h3>
        {renderStrapiContent(the_wine)}
      </div>
    );
  };

  const renderKeywords = () => {
    return (
      <p className="i small-text">
        {keywords.map((kw, i, arr) => {
          if (i === arr.length - 1) {
            return <span key={kw}>{kw}</span>;
          }
          return <span key={kw}>{kw}, </span>;
        })}
      </p>
    );
  };

  return (
    <div>
      <div className="wine-modal">
        <div className="d-flex flex-column align-items-center">
          {wineArt && (
            <img
              className="wine-modal-art"
              src={wineArt}
              alt={wine_name + " label art"}
            />
          )}
          <h2 className="m-t-20">{wine_name}</h2>
        </div>
        {keywords && keywords.length > 0 && renderKeywords()}
        <p className="m-t-50">{description}</p>
        {the_wine && renderWine()}
        {the_grape && renderGrape()}
        {the_name && renderName()}
      </div>
    </div>
  );
};

export default WineModal;
